import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  initialModalTicketListState,
  TicketingApiResponseStatus,
  TicketListItem,
} from '@Src/store/types';
import { RootState } from '@Src/store';
import { getTicketListApi } from '@Src/apiServices/ticketingService';
import { apiLoading, apiRejected } from '@Src/store/reducers/Ticketing/helpers';

export const fetchModalTicketList = createAsyncThunk(
  'fetchModalTicketList',
  async (fetchModalTicketListApiRequest: any) => {
    const { appSource } = fetchModalTicketListApiRequest;

    const params = new Map<string, string>();
    params.set('page', '1');
    params.set('per_page', '10');
    return getTicketListApi(Object.fromEntries(params), appSource);
  }
);

export const modalTicketListSlice = createSlice({
  name: 'ticketList',
  initialState: initialModalTicketListState,
  reducers: {
    clearTicketList: (state, action) => {
      state.ticketList = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchModalTicketList.pending, apiLoading)
      .addCase(fetchModalTicketList.rejected, apiRejected)
      .addCase(fetchModalTicketList.fulfilled, (state, action) => {
        const { tickets } = action.payload;
        if (!tickets) {
          state.status = TicketingApiResponseStatus.failed;
          return;
        }
        state.status = TicketingApiResponseStatus.succeeded;

        if (state.ticketList && state.ticketList.length) {
          return;
        }
        const presentIds: TicketListItem['id'][] = state.ticketList.map(
          (tickets) => tickets.id
        );
        tickets.forEach((ticket: any) => {
          const tick: TicketListItem = ((TicketListItem) => TicketListItem)(
            ticket
          );
          if (!presentIds.includes(tick.id)) {
            state.ticketList.push(tick);
          }
        });
      });
  },
});

export const getModalTicketList = (store: RootState) =>
  store.ticketingModalReducer.ticketList;
export const getModalTicketListStatus = (store: RootState) =>
  store.ticketingModalReducer.status;
export default modalTicketListSlice.reducer;
